import { EntityModel } from '@/interfaces'
import {
  ALL_HIGHLIGHTS_QUERY,
  CREATE_HIGHLIGHT_MUTATION,
  DELETE_HIGHLIGHT_MUTATION,
  FORCE_DELETE_HIGHLIGHT_MUTATION,
  SINGLE_HIGHLIGHT_QUERY,
  UPDATE_HIGHLIGHT_MUTATION,
} from './graphql'

const travelHighlightModel: EntityModel = {
  name: 'highlight',
  namePlural: 'highlights',
  uniqueName: 'travelHighlight',
  uniqueNamePlural: 'travelHighlights',
  path: 'travel/highlight',
  baseUrl: '/travel/highlights',
  translationPrefix: 'entities:travelHighlight.',
  getDisplayName: (values: any) => {
    return values.text
  },
  gql: {
    getAll: ALL_HIGHLIGHTS_QUERY,
    getSingle: SINGLE_HIGHLIGHT_QUERY,
    create: CREATE_HIGHLIGHT_MUTATION,
    update: UPDATE_HIGHLIGHT_MUTATION,
    delete: DELETE_HIGHLIGHT_MUTATION,
    forceDelete: FORCE_DELETE_HIGHLIGHT_MUTATION,
  },
  attributes: {
    text: {
      name: 'text',
      label: 'entities:travelHighlight.attributes.text.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
  },
}

export default travelHighlightModel
